<template>
    <div>
        <StatusTrack
            :sections="trackerSections"
            :is-completed="completed === toComplete"
            :show-helper="showHelper"
            @save="$emit('saveExit')"
            @next="$emit('saveNext', 2)"
        />

        <section id="general">
            <SectionHeader
                heading="General"
                :completed="completed"
                :to-complete="toComplete"
            />

            <SectionGroup
                id="responsiblePerson"
                heading="Responsible person"
                :validated.sync="validated.responsiblePerson"
            >
                <InputField label="CEC Accredited Installers Name" name="installerName" type="text" required readonly :value.sync="data.installerName" />
                <InputField label="CEC Accreditation No." name="installerNumber" type="text" required readonly :value.sync="data.installerNumber" />
                <InputField label="CEC Accredited Designers Name" name="designerName" type="text" required readonly :value.sync="data.designerName" />
                <InputField label="CEC Accreditation No." name="designerNumber" type="text" required readonly :value.sync="data.designerNumber" />
                <InputField label="Licensed Electricians Name" name="electricianName" type="text" :value.sync="data.electricianName" />
                <InputField label="Licensed Electricians No." name="electricianNumber" type="text" :value.sync="data.electricianNumber" />
            </SectionGroup>


            <SectionGroup
                id="jobDetails"
                heading="Job details"
                :validated.sync="validated.jobDetails"
            >
                <template #default="{ validate }">
                    <InputField class="field--full" label="System address" name="addressString" type="text" required readonly :value.sync="data.address" />
                    <InputField label="Systems owner’s name" name="ownerName" type="text" required readonly :value.sync="data.name" />
                    <InputField label="System owner’s email address" name="ownerEmail" type="text" required readonly :value.sync="data.email" />

                    <InputField label="System owner’s phone number" name="phone" type="text" :value.sync="data.phone" />
                    <InputField label="Job number" name="jobNumber" type="text" :value.sync="data.jobNumber" />

                    <FieldDate :value="data.installationDate" label="Date of installation" placeholder="DD/MM/YYYY" @input="updateInstallationDate($event)" />

                    <InputField label="Building type" name="buildingType" type="text" required readonly :value.sync="data.buildingType" />

                    <InputField label="National meter identifier (NMI)" name="nmi" type="text" required :value.sync="data.nmi" @validate="validate" />
                    <InputField label="Meter number" name="meterNumber" type="text" required :value.sync="data.meterNumber" @validate="validate" />
                    <InputField label="Number of phases (electrical installation)" name="noOfPhases" type="number" required :value.sync="data.noOfPhases" @validate="validate" />
                    <InputField label="Energy retailer at the time of commissioning" name="energyRetailer" type="text" :value.sync="data.energyRetailer" />
                    <InputField label="Network preapproval reference" name="networkRef" type="text" :value.sync="data.networkRef" />

                    <SelectField
                        label="Distribution network service provider (DNSP)"
                        placeholder="Select Option"
                        :options="['Ausnet Services', 'Jemena', 'Citipower', 'Powercor', 'United Energy', 'Energex', 'Ergon Energy', 'Essential Energy', 'Ausgrid', 'Endeavour Energy', 'SA Power Networks', 'Horizon Power', 'Western Power', 'Evoenergy', 'NT Power and Water', 'TasNetworks']"
                        name="dnsp"
                        :value.sync="data.dnsp"
                    />

                    <SelectField
                        label="Export Limitation Required - Whole System"
                        :options="['No', 'Yes']"
                        name="exportLimitationRequired"
                        :value.sync="data.exportLimitationRequired"
                    />

                    <InputField v-if="data.exportLimitationRequired === 'Yes'" label="Limited to (W)" name="limitedTo" type="number" :value.sync="data.limitedTo" />
                </template>
            </SectionGroup>
        </section>
        <div class="commissioning-sheet__btn">
            <button class="btn mt-xl mr-xs" @click="$emit('saveExit')">Save and exit</button>
            <button class="btn mt-xl" @click="$emit('saveNext', 2)">Continue</button>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-console */
import InputField from './InputField';
import SelectField from './SelectField';
import SectionHeader from './SectionHeader';
import SectionGroup from './SectionGroup';
import StatusTrack from './StatusTrack';
import FieldDate from '@/form/Date';

export default {
    components: {
        SectionHeader,
        SectionGroup,
        InputField,
        SelectField,
        FieldDate,
        StatusTrack
    },

    props: {
        commissioningSheet: {
            type: Object,
            required: true,
        },
        jobObject: {
            type: Object,
            required: true,
        },
        showHelper: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            validated: {
                responsiblePerson: false,
                jobDetails: false,
            },
            toComplete: 2,
            data: this.commissioningSheet.general,
        };
    },

    computed: {
        completed() {
            return Object.values(this.validated).filter(item => item === true).length;
        },

        trackerSections() {
            const tracker = [];
            tracker.push({
                title: 'General',
                id: '#general',
                completed: this.completed,
                toComplete: this.toComplete,
            })

            return tracker;
        }
    },

    watch: {
        completed() {
            this.$emit('validateStep', 0 , this.completed === this.toComplete);
        }
    },

    mounted() {
        // Check for newly updated values in Job details
        const { phone, jobNumber, meterNumber, nmi } = this.jobObject.details;

        if (phone && phone !== '') {
            this.data.phone = phone;
        }

        if (jobNumber && jobNumber !== '') {
            this.data.jobNumber = jobNumber;
        }

        if (nmi && nmi !== '') {
            this.data.nmi = nmi;
        }

        if (meterNumber && meterNumber !== '') {
            this.data.meterNumber = meterNumber;
        }

        this.$emit('validateStep', 0 , this.completed === this.toComplete);
    },

    methods: {
        updateInstallationDate(value) {
            this.data.installationDate = value;
        }
    },

}
</script>
